import {configureStore} from "@reduxjs/toolkit"
import userSliceReducer from "./userSlice"
import productSliceReducer from "./productSlice"
import gallerySliceReducer from "./gallerySlice"

export const store=configureStore({
    
    reducer: {
        user : userSliceReducer,
        product : productSliceReducer,
        gallery: gallerySliceReducer
    },
})